export default __webpack_public_path__ + "static/media/Output_ToScreen_Active.af3a408c.svg";